<template>
  <span v-dompurify-html="this.highlight()"></span>
</template>

<script>
export default {
  props: [
    "input", // Content to highlight
    "searchPhrases" // Search in content for highlight (array)
  ],
  methods: {
    highlight() {
      //Highlight all found search phrases
      let displayText = this.input || "";
      if (!displayText) return "";
      for (let j = 0; j < this.searchPhrases.length; j++) {
        displayText = displayText.replace(new RegExp(this.searchPhrases[j], "gi"), (match) => `<span class="highlight">${match}</span>`);
      }

      //Difference the highlights in alternate styles
      //If don't need, remove the code below and the highlight0 and the highlight1 class from css
      let cnt = 0;
      displayText = displayText.replace(new RegExp(/"highlight"/, "gi"), function () {
        cnt++;
        return "highlight" + (cnt % 2 ? "0" : "1");
      });
      //End of highlight difference code
      return displayText;
    }
  }
};
</script>
<style />
